export default {
      id: "tickets-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "img/icons.svg#tickets",
      toString: function () {
        return this.url;
      }
    }